<template>
  <div>
    <el-date-picker
      v-model="monthsQuery"
      type="month"
      :clearable="false"
      :value-format="'yyyy-MM-dd HH:mm:ss'"
      @change="onChangeMonths"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
    <el-table
      :data="tableData"
      show-summary
      height="680"
      ref="myTable"
      v-if="deviceType == 0"
    >
      <el-table-column
        :label="$t('lang.时间')"
        align="center"
        prop="dataTimeShow"
      >
      </el-table-column>
      <el-table-column
        :label="$t('lang.用电量kwh')"
        align="center"
        prop="useKwh"
        :formatter="formatter"
      >
      </el-table-column>
    </el-table>
    <el-table
      :data="tableData"
      show-summary
      height="680"
      ref="myTable"
      v-else-if="deviceType == 1"
    >
      <el-table-column
        :label="$t('lang.时间')"
        align="center"
        prop="dataTimeShow"
      >
      </el-table-column>
      <el-table-column
        :label="$t('lang.用水量m')"
        align="center"
        prop="useWater"
        :formatter="formatter"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      monthsQuery: moment().format("YYYY-MM-01 00:00:00"),
      tableData: [],
      deviceType: 0,
      pointId: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      expenseDetails: "ZD_ExpenseDetails",
      waterExpenseDetails: "ZD_WaterExpenseDetails",
    }),
    async getOperationRecord(pointId, deviceType = null) {
      this.pointId = pointId;
      if (deviceType !== null) this.deviceType = deviceType;
      let res = {};
      switch (this.deviceType) {
        case 0:
          res = await this.expenseDetails({
            pointId: pointId,
            queryTime: this.monthsQuery,
          });
          if (res.success !== 1) return;
          this.tableData = res.listitem;
          break;
        case 1:
          res = await this.waterExpenseDetails({
            pointId: pointId,
            queryTime: this.monthsQuery,
          });
          if (res.success !== 1) return;
          this.tableData = res.listitem;
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        this.$refs.myTable?.doLayout(); // 强制更新表格布局
      });
    },
    onChangeMonths() {
      this.getOperationRecord(this.pointId);
    },
    formatter(row, { property }) {
      if (property == "useKwh") {
        return Number(row.useKwh).toFixed(2);
      } else if (property == "useWater") {
        return Number(row.useWater).toFixed(2);
      }
    },
  },
};
</script>

<style scoped lang='less'>
/deep/ .has-gutter tr td {
  background: #c6e2ff;
}
</style>
